module.exports = {"id":"234870","name":"Efecan Karaca","rating":"72","photo":"./data/images/photos/3/234870.png","club":{"name":"Aytemiz Alanyaspor","logo":"./data/images/clubs/AytemizAlanyaspor.png"},"positions":["MOC","MDC","MC","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EfecanKaraca0.json
// module id = 1195
// module chunks = 0